<template>
    <div class="border-b mt-4 pb-2">
        <div class="ml-2 xl:ml-4 mr-4">
            <div class="b-2 xl:mb-0 flex justify-center">
                <button type="button" class="flex" title="View customer info">
                    <!-- <svg-vue icon="avatar" title="Profile" class="w-6 h-6 inline-block mr-2 default-avatar-icon" /> -->
                    <img
                        v-show="!showingDefaultAvatar"
                        @load="showingDefaultAvater = false"
                        class="w-12 h-12 z-0 mr-2 rounded-full outline:none hover:cursor-default default-avatar-icon"
                    />
                    <svg-vue
                        v-show="showingDefaultAvatar"
                        icon="circle-user"
                        title="default user avatar"
                        class="h-12 mr-2 hover:cursor-pointer"
                    />
                    <div class="text-hint font-bold text-xl justify-start">
                        {{ newMember.user.display_name }}

                        <p class="italic text-md">{{ subindustryString }}</p>
                    </div>
                </button>
            </div>
        </div>
        <div class="flex items-center ml-12 mt-4">
            <button
                class="storefront-btn-blue ml-0 mr-0"
                type="button"
                @click="status(true)"
            >
                <span class="inline-block"> Accept </span>
            </button>

            <button
                class="ml-3 storefront-btn-blue"
                type="button"
                @click="status(false)"
            >
                <span class="inline-block"> Reject </span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showingDefaultAvatar: true,
            decisionData: {
                acceptingMember: false,
                user_id: "",
                organization_id: "",
            },
        };
    },
    props: ["newMember", "organization"],
    methods: {
        submitMemberRequest() {
            axios
                .put(
                    "/api/organizations/" + this.organization.id + "/addUser",
                    this.decisionData
                )
                .then((response) => {
                    window.location.reload();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        status(option) {
            if (option) {
                this.decisionData.acceptingMember = true;
            } else {
                this.decisionData.acceptingMember = false;
            }

            this.decisionData.user_id = this.newMember.user_id;
            this.decisionData.organization_id = this.organization.id;
            this.submitMemberRequest();
        },
    },
    computed:{
        subindustryString() {
            if (this.newMember.subindustry != null) {
                return this.newMember.subindustry.tag
                    .replaceAll("_", " ")
                    .substring(1);
            } else {
                return " ";
            }
        },
    },
};
</script>
